import React, { useEffect, useState } from "react";
import { Dropdown, Nav, Navbar } from "rsuite";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import * as userManager from '../../Services/UserSessionManager';
import * as log from '../../Services/LoginADservice';
import { Link, useNavigate } from "react-router-dom";
import './Home.css';

export  const ProfileDropDown=()=>{
    // const Logout = () => {
    //     userManager.SetUserToken('');
    //     sessionStorage.clear();
    //     window.location.reload();
        
    // }
    const Logout=()=> {
        log.Logout().then(res=>{
          if (res.status == 200) {
            window.location.href = process.env.REACT_APP_STEM_FUSIONAUTH+"logout?client_id="+process.env.REACT_APP_STEM_CLIENTID+"&post_logout_redirect_uri="+process.env.REACT_APP_STEM_CLIENT;
          }
        });
    
      }
   const [checkRole,setCheckRole]=useState(userManager.GetUserRole());

    const[loginid,setLoginid]=useState(userManager.GetUserLoginID());
    const[userName,setUserName]=useState(userManager.GetUserName());
    const[popup,setpopUp]=useState(false);
    const handleClose=()=>setpopUp(false);

    const showPopUp=()=>{
        setpopUp(true); 
    }

    return(
       <>
    
   

        
        <Dropdown title={userManager.GetUserName()} 
                className="nav-bar-text-white"
                onClick={Logout}
                icon={<BootstrapIcon cssClasses="p-2 nav-bar-text-white" bootStrapIconName="box-arrow-right" size={18} />} 
                noCaret>
            </Dropdown>           

          
         </>
    )
}
